import { render, staticRenderFns } from "./ProductVariantsModal.vue?vue&type=template&id=b917d43c&scoped=true&"
import script from "./ProductVariantsModal.vue?vue&type=script&lang=js&"
export * from "./ProductVariantsModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductVariantsModal.vue?vue&type=style&index=0&id=b917d43c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b917d43c",
  null
  
)

export default component.exports